import React from 'react';

const Cell = ({ value, style }) => (
  <div style={style}>{value ? `${value}` : ''}</div>
);

export default Cell;
